var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:( _obj = {}, _obj['badge--' + _vm.type] = _vm.type, _obj )},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),(_vm.value)?_c('small',{staticClass:"badge__value",domProps:{"textContent":_vm._s(_vm.value)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }